import { Theme } from '@material-ui/core/styles/createTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      [theme.breakpoints.down('xs')]: {
        marginTop: '16px',
      },
    },
    title: {
      [theme.breakpoints.down('xs')]: {
        fontSize: '19px',
        fontWeight: 700,
      },
    },
    docs: {
      margin: theme.spacing(4, 0),
      '& > .MuiGrid-item': {
        padding: theme.spacing(2, 1, 2, 0),
      },
    },
    docLine: {
      borderBottom: 'solid #ccc 1px',
      paddingLeft: 0,

      '&:hover': {
        background: '#f6f6f6',
      },
      '& > div': {
        [theme.breakpoints.down('xs')]: {
          padding: theme.spacing(2, 0, 0, 0),
        },

        '&:first-child': {
          [theme.breakpoints.down('xs')]: {
            fontSize: '14px',
            fontWeight: 700,
          },
        },
        '&:last-child': {
          display: 'flex',
          justifyContent: 'flex-end',
          '& button': {
            margin: theme.spacing(0.5),
            '@media (max-width: 400px)': {
              marginTop: theme.spacing(1),
              marginBottom: 0,
            },
          },
        },
      },
      [theme.breakpoints.down('xs')]: {
        alignItems: 'flex-end',
      },
    },
    requestActions: {
      '@media (max-width: 800px)': {
        flexWrap: 'wrap',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
    actions: {
      flexWrap: 'nowrap',
      '& .MuiButton-root': {
        height: '100%',
        margin: theme.spacing(0, 0.5),
        '@media (max-width: 400px)': {
          margin: 0,
        },
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: '100%',
      },
    },
    pdfContainer: {
      alignItems: 'center',
    },
    buttonWrapper: {
      display: 'flex',
      marginTop: theme.spacing(2),
      justifyContent: 'center',
      '@media (max-width: 560px)': {
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(0, -2),
        '& button': {
          marginTop: theme.spacing(2),
        },
      },
    },
    actionButton: {
      margin: theme.spacing(0, 1),
    },
    confirmButton: {
      '&.MuiButton-textSizeLarge': {
        padding: 0,
        minWidth: 0,
      },
      '& .MuiButton-iconSizeLarge > .MuiSvgIcon-root:first-child': {
        fontSize: '2.1875rem',
        margin: '0',
      },
    },
    viewButton: {
      '& .MuiButton-iconSizeLarge > .MuiSvgIcon-root:first-child': {
        fontSize: '2.1875rem',
        margin: '0',
      },
    },
    confirmedWrapper: {
      '@media (max-width: 400px)': {
        flex: 0,
        minWidth: '100%',
      },
    },

    confirmed: {
      whiteSpace: 'nowrap',
      '& > strong': {
        width: '100%',
        '& > svg': {
          marginRight: theme.spacing(0.5),
          marginBottom: theme.spacing(0.5),
        },
      },
      '& > *': {
        display: 'flex',
        alignItems: 'center',
      },
      '@media (max-width: 400px)': {
        display: 'flex',
        '& > strong': { width: 'auto', marginRight: theme.spacing(2) },
      },
    },
    error: {
      padding: theme.spacing(1),
      color: theme.palette.error.main,
    },
    previewDialog: {
      '& .MuiDialogTitle-root': { borderBottom: 'solid #ccc 1px', background: '#fff', zIndex: 1 },
      '& .MuiDialogActions-root': { borderTop: 'solid #ccc 1px' },
      '& .MuiDialogContent-root': { marginTop: 0 },
    },
  }),
);
